import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'caretDownSmall',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-caret-down-small wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M12.288 15.866c.117.18.31.177.424 0l4.235-6.538c.116-.18.034-.328-.176-.328H8.229c-.214 0-.29.15-.176.328l4.235 6.538z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-caret-down-small.svg',
    category: 'Core',
    tags: ['navigation', 'arrow', 'triangle', 'data', 'table', 'grid'],
};
export default icon;
